export const zBagLabel = (order) => {
    return `
^XA

^CI28
^FO15,25^FB600,2,1,C^A0,55,45^FD${order.student}^FS
^FO15,140^FB600,2,1,C^A0,35^FD${order.school}^FS
^FO15,225^FB600,2,1,C^A0,55^FD${order.grade}^FS

^XZ
`
}